import { IconButton, Tooltip } from "@mui/material";
import Iconify from "../../minimals/components/iconify";

export default function VersionBarcodeButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip title="Generate Version QR Code">
      <IconButton size="small" color="primary" onClick={onClick} aria-label="Generate Version QR Code">
        <Iconify icon="mdi:qrcode" />
      </IconButton>
    </Tooltip>
  );
}
